//#region src/generated/schemas.gen.ts
var e = {
	type: "string",
	enum: ["MINUTES"]
}, t = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The sales channel ID."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "Sales channel created at."
		},
		extraction: {
			type: "object",
			properties: { lastCycle: {
				type: "object",
				properties: {
					extractedAt: {
						type: "string",
						format: "date-time",
						description: "Last order extraction attempt at."
					},
					successfullyExtractedAt: {
						type: "string",
						format: "date-time",
						description: "Last successful order extraction at."
					},
					transformedAndLoadedAt: {
						type: "string",
						format: "date-time",
						description: "Last order extraction and loading attempt at."
					},
					successfullyTransformedAndLoadedAt: {
						type: "string",
						format: "date-time",
						description: "Last successful order extraction and loading at."
					}
				},
				description: "Last order extraction cycle."
			} },
			description: "Order extraction configuration."
		},
		fulfilmentPlatforms: {
			type: "array",
			items: {
				type: "string",
				enum: ["VASCO"],
				description: "The fulfilment platform."
			},
			minItems: 1,
			maxItems: 1,
			description: "The fulfilment platforms."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "Custom sales channel name."
		},
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "Owning shop ID for the sales channel."
		},
		url: {
			type: "string",
			maxLength: 250,
			format: "uri",
			description: "The URL of the Lightspeed store."
		},
		authorizeUrl: {
			type: "string",
			format: "uri",
			description: "Authorization URL for the sales channel."
		},
		status: {
			type: "string",
			enum: ["DELEGATION_REQUESTED"],
			description: "Connection status which indicates that a connection authorization has been requested but not yet confirmed."
		}
	},
	required: [
		"id",
		"createdAt",
		"name",
		"shopId",
		"url",
		"authorizeUrl",
		"status"
	]
}, n = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The sales channel ID."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "Sales channel created at."
		},
		extraction: {
			type: "object",
			properties: { lastCycle: {
				type: "object",
				properties: {
					extractedAt: {
						type: "string",
						format: "date-time",
						description: "Last order extraction attempt at."
					},
					successfullyExtractedAt: {
						type: "string",
						format: "date-time",
						description: "Last successful order extraction at."
					},
					transformedAndLoadedAt: {
						type: "string",
						format: "date-time",
						description: "Last order extraction and loading attempt at."
					},
					successfullyTransformedAndLoadedAt: {
						type: "string",
						format: "date-time",
						description: "Last successful order extraction and loading at."
					}
				},
				description: "Last order extraction cycle."
			} },
			description: "Order extraction configuration."
		},
		fulfilmentPlatforms: {
			type: "array",
			items: {
				type: "string",
				enum: ["VASCO"],
				description: "The fulfilment platform."
			},
			minItems: 1,
			maxItems: 1,
			description: "The fulfilment platforms."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "Custom sales channel name."
		},
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "Owning shop ID for the sales channel."
		},
		url: {
			type: "string",
			maxLength: 250,
			format: "uri",
			description: "The URL of the Lightspeed store."
		},
		delegationError: {
			type: "object",
			properties: {
				reason: {
					type: "string",
					description: "Error reason."
				},
				details: {
					type: "string",
					description: "More detailed information about the error."
				}
			},
			required: ["reason"],
			description: "Delegation error."
		},
		status: {
			type: "string",
			enum: ["DELEGATION_REQUIRED"],
			description: "Connection status which indicates that a connection authorization is required."
		}
	},
	required: [
		"id",
		"createdAt",
		"name",
		"shopId",
		"url",
		"delegationError",
		"status"
	]
}, r = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: [
				"about:blank",
				"urn:problem:client",
				"urn:problem:invalid-request-syntax",
				"urn:problem:not-found",
				"urn:problem:server",
				"urn:problem:unauthorized",
				"urn:problem:unsupported-media-type"
			],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "integer",
			enum: [
				400,
				401,
				404,
				415,
				500
			],
			description: "The HTTP status code generated by the origin server."
		},
		title: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "A short human-readable summary of the problem type."
		},
		detail: {
			type: "string",
			minLength: 1,
			maxLength: 5e3,
			description: "A human-readable explanation specific to this occurrence of the problem."
		},
		instance: {
			type: "string",
			format: "uri",
			description: "A URI reference that identifies the specific occurrence of the problem."
		},
		cause: { description: "The cause of this problem when debug mode is enabled." }
	},
	required: [
		"type",
		"status",
		"title",
		"detail",
		"instance"
	]
}, i = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:invalid-request-syntax"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the syntactic violations."
		}
	},
	required: ["errors"]
}] }, a = {
	type: "object",
	properties: {
		fulfilmentPlatforms: {
			type: "array",
			items: {
				type: "string",
				enum: ["VASCO"],
				description: "The fulfilment platform."
			},
			minItems: 1,
			maxItems: 1,
			description: "Set of fulfilment platforms."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "The name of the sales channel."
		},
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The shop ID."
		},
		url: {
			type: "string",
			maxLength: 250,
			format: "uri"
		}
	},
	required: [
		"name",
		"shopId",
		"url"
	],
	examples: [{
		fulfilmentPlatforms: ["VASCO"],
		name: "Sales channel name",
		shopId: "1234",
		url: "https://example.com"
	}]
}, o = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The sales channel ID."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "Sales channel created at."
		},
		extraction: {
			type: "object",
			properties: {
				lastCycle: {
					type: "object",
					properties: {
						extractedAt: {
							type: "string",
							format: "date-time",
							description: "Last order extraction attempt at."
						},
						successfullyExtractedAt: {
							type: "string",
							format: "date-time",
							description: "Last successful order extraction at."
						},
						transformedAndLoadedAt: {
							type: "string",
							format: "date-time",
							description: "Last order extraction and loading attempt at."
						},
						successfullyTransformedAndLoadedAt: {
							type: "string",
							format: "date-time",
							description: "Last successful order extraction and loading at."
						}
					},
					description: "Last order extraction cycle."
				},
				schedule: {
					type: "object",
					properties: {
						transformAndLoad: {
							type: "boolean",
							description: "Whether orders should be automatically imported."
						},
						unit: { allOf: [{ $ref: "#/components/schemas/ExtractionScheduleUnit" }, { description: "Time unit which is used for scheduled order loading." }] },
						value: {
							type: "integer",
							exclusiveMinimum: 0,
							description: "Amount of time units between each scheduled order loading attempt."
						}
					},
					required: [
						"transformAndLoad",
						"unit",
						"value"
					],
					description: "Schedule which is used for order loading."
				}
			},
			required: ["schedule"],
			description: "Order extraction configuration."
		},
		fulfilmentPlatforms: {
			type: "array",
			items: {
				type: "string",
				enum: ["VASCO"],
				description: "The fulfilment platform."
			},
			minItems: 1,
			maxItems: 1,
			description: "The fulfilment platforms."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "Custom sales channel name."
		},
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "Owning shop ID for the sales channel."
		},
		url: {
			type: "string",
			maxLength: 250,
			format: "uri",
			description: "The URL of the Lightspeed store."
		},
		apiCredentialsLastTokens: {
			type: "object",
			properties: {
				key: {
					type: "string",
					minLength: 4,
					maxLength: 4,
					description: "API key."
				},
				secret: {
					type: "string",
					minLength: 4,
					maxLength: 4,
					description: "API secret."
				}
			},
			required: ["key", "secret"],
			description: "Last N tokens when API credentials are used."
		},
		status: {
			type: "string",
			enum: ["DELEGATION_ISSUED"],
			description: "Status for the connection with the sales channel for which orders will be extracted from."
		}
	},
	required: [
		"id",
		"createdAt",
		"extraction",
		"name",
		"shopId",
		"url",
		"apiCredentialsLastTokens",
		"status"
	]
}, s = {
	type: "object",
	properties: { salesChannelId: {
		type: "string",
		format: "uuid",
		description: "The sales channel ID."
	} },
	required: ["salesChannelId"],
	examples: [{ salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6" }]
}, c = {
	type: "object",
	properties: { salesChannelId: {
		type: "string",
		format: "uuid",
		description: "The sales channel ID."
	} },
	required: ["salesChannelId"],
	examples: [{ salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6" }]
}, l = {
	type: "object",
	properties: { salesChannelIds: {
		type: "array",
		items: {
			type: "string",
			format: "uuid"
		},
		minItems: 1,
		maxItems: 150,
		description: "The sales channel id to import products for"
	} },
	required: ["salesChannelIds"]
}, u = {
	oneOf: [
		{ $ref: "#/components/schemas/SalesChannelWithStatusDelegationRequired" },
		{ $ref: "#/components/schemas/SalesChannelWithStatusDelegationIssued" },
		{ $ref: "#/components/schemas/SalesChannelWithStatusDelegationRequested" }
	],
	discriminator: {
		propertyName: "status",
		mapping: {
			DELEGATION_REQUIRED: "#/components/schemas/SalesChannelWithStatusDelegationRequired",
			DELEGATION_ISSUED: "#/components/schemas/SalesChannelWithStatusDelegationIssued",
			DELEGATION_REQUESTED: "#/components/schemas/SalesChannelWithStatusDelegationRequested"
		}
	}
}, d = {
	type: "object",
	properties: {
		salesChannelId: {
			type: "string",
			format: "uuid",
			description: "The sales channel ID."
		},
		fulfilmentPlatforms: {
			type: "array",
			items: {
				type: "string",
				enum: ["VASCO"],
				description: "The fulfilment platform."
			},
			minItems: 1,
			maxItems: 1,
			description: "The fulfilment platforms."
		}
	},
	required: ["salesChannelId"],
	examples: [{
		salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		fulfilmentPlatforms: ["VASCO"]
	}]
}, f = {
	type: "object",
	properties: { salesChannelId: {
		type: "string",
		format: "uuid",
		description: "The ID of the sales channel."
	} },
	required: ["salesChannelId"],
	examples: [{ salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6" }]
}, p = {
	type: "object",
	properties: {
		salesChannelId: {
			type: "string",
			format: "uuid",
			description: "The ID of the sales channel."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "The name of the sales channel."
		}
	},
	required: ["salesChannelId", "name"],
	examples: [{
		salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		name: "New sales channel name"
	}]
}, m = {
	type: "object",
	properties: { salesChannelId: {
		type: "string",
		format: "uuid",
		description: "The sales channel ID."
	} },
	required: ["salesChannelId"],
	examples: [{ salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6" }]
}, h = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:not-found"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [404],
			description: "The HTTP status code generated by the origin server."
		}
	}
}] };
//#endregion
export { l as a, h as c, p as d, m as f, n as g, t as h, e as i, r as l, o as m, s as n, d as o, u as p, c as r, i as s, a as t, f as u };
